import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { NELType } from '@insights_module/types/NEL';
import { fetchLinkedNamedEntitiesById } from '@services/index';

export const useFetchLinkedNamedEntities = (ids: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['linked-named-entities-metadata', ids],
    queryFn: () => fetchLinkedNamedEntitiesById(ids),
    staleTime: 60 * 60 * 1000, // 1 hour
    enabled: !!ids.length,
  });

  const loading = useMemo(() => isLoading && ids?.length, [isLoading, ids]);

  return {
    ids,
    data: data?.data || ([] as NELType[]),
    isLoading: loading,
  };
};
